import { useEffect, useState } from 'react';
import { Button, InputAdornment, Typography } from '@mui/material';

import CustomInput from '../CustomInput';

import { ButtonInputType } from './props';

const PhoneInput = ({
  countryCode = '+60',
  hasCountryCode = true,
  hasButtonEnd = true,
  buttonProps,
  buttonText,
  countDownTime = 60,
  onClickAction,
  outlinedInputProps,
  countryCodeProps,
  validation = /^\d{9,10}$/g,
  ...props
}: ButtonInputType) => {
  // ================ STATE
  const [countdown, setCountdown] = useState<number>(countDownTime);
  const [isCounting, setIsCounting] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  // ================ VARIABLES
  const displayText =
    buttonText || (isCounting ? `${countdown}S` : 'Request OTP');

  // ================ HOOKS
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isCounting) {
      timer = setTimeout(() => {
        setCountdown((prevCountdown) =>
          prevCountdown ? prevCountdown - 1 : 0
        );
      }, 1000);
    }

    if (countdown === 0) {
      setIsCounting(false);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [countdown, isCounting]);

  // ================ EVENT
  const handleAction = () => {
    setCountdown(60);
    setIsCounting(true);
    if (onClickAction && typeof onClickAction === 'function') {
      onClickAction(value);
    }
  };

  // ================ VIEWS
  return (
    <CustomInput
      outlinedInputProps={{
        type: 'text',
        sx: { paddingRight: 0 },
        onChange: (e) => setValue(e.target.value),
        startAdornment: hasCountryCode && (
          <InputAdornment position="start">
            <Typography fontSize={'0.875rem'} {...countryCodeProps}>
              {countryCode}
            </Typography>
          </InputAdornment>
        ),
        endAdornment: hasButtonEnd && (
          <Button
            sx={{
              height: '100%',
              minWidth: '30%',
              borderEndStartRadius: 0,
              borderStartStartRadius: 0,
              whiteSpace: 'nowrap',
            }}
            onClick={handleAction}
            variant="contained"
            disabled={isCounting || !value.match(validation)}
            {...buttonProps}
          >
            {displayText}
          </Button>
        ),
        ...outlinedInputProps,
      }}
      {...props}
    />
  );
};

export default PhoneInput;
